var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisterUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2815_2326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4999 12.4997C28.9291 12.4997 30.9166 14.3747 30.9166 16.6663C30.9166 18.958 28.9291 20.833 26.4999 20.833C24.0707 20.833 22.0832 18.958 22.0832 16.6663C22.0832 14.3747 24.0707 12.4997 26.4999 12.4997ZM26.4999 31.2497C32.4624 31.2497 39.3082 33.9372 39.7499 35.4163V37.4997H13.2499V35.4372C13.6916 33.9372 20.5374 31.2497 26.4999 31.2497ZM26.4999 8.33301C21.6195 8.33301 17.6666 12.0622 17.6666 16.6663C17.6666 21.2705 21.6195 24.9997 26.4999 24.9997C31.3803 24.9997 35.3332 21.2705 35.3332 16.6663C35.3332 12.0622 31.3803 8.33301 26.4999 8.33301ZM26.4999 27.083C20.6037 27.083 8.83325 29.8747 8.83325 35.4163V41.6663H44.1666V35.4163C44.1666 29.8747 32.3962 27.083 26.4999 27.083Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8601 43.175H37.0226V47V48.8H38.8226H42.7976H44.5976V47V43.175H48.7601H50.5601V41.375V37.625V35.825H48.7601H44.5976V32V30.2H42.7976H38.8226H37.0226V32V35.825H32.8601H31.0601V37.625V41.375V43.175H32.8601Z",
    fill: "#515151",
    stroke: "white",
    strokeWidth: 3.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2815_2326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterUser);
export default __webpack_public_path__ + "static/media/register-user.ec0aabf554af29c7d49918606bcae1a6.svg";
export { ForwardRef as ReactComponent };